import { Link, useNavigate } from "react-router-dom";
import { useState, useContext, useEffect, useRef } from "react";
import "./Navbar.css";
import logo from "../assets/images/logo.png";
import { AuthContext } from "../context/AuthContext";
import { FiSearch, FiShoppingCart, FiUser, FiMenu, FiX, FiChevronDown } from "react-icons/fi";
import { FaEnvelope, FaPhone } from "react-icons/fa";
import { BACKEND_URL } from "../config";



function Navbar() {

  const [dbCategories, setDbCategories] = useState([]);
  const [activeMobileCatId, setActiveMobileCatId] = useState(null);

  const [products, setProducts] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [mobileUserOpen, setMobileUserOpen] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const [langOpen, setLangOpen] = useState(false);
  const [selectedFlag, setSelectedFlag] = useState(
  "https://flagcdn.com/w20/gb.png"
);

  const changeLanguage = (langCode, flag) => {
  const select = document.querySelector(".goog-te-combo");

  if (select) {
    select.value = langCode;
    select.dispatchEvent(new Event("change"));
  }

  setSelectedFlag(flag);
  setLangOpen(false);
};

// WITH this new one:
useEffect(() => {
  const updateCount = () => {
    const cart = JSON.parse(localStorage.getItem("cart")) || [];
    setCartCount(cart.length);
  };

  updateCount(); // initial load

  window.addEventListener("cartUpdated", updateCount);   // same-tab updates
  window.addEventListener("storage", updateCount);       // other-tab updates

  return () => {
    window.removeEventListener("cartUpdated", updateCount);
    window.removeEventListener("storage", updateCount);
  };
}, []);
  
  const mobilePopupRef = useRef(null);
  const searchRef = useRef(null);
  const userRef = useRef(null);

  const navigate = useNavigate();
  const { user, setUser, setShowAuth, setAuthMode } = useContext(AuthContext);

  

  useEffect(() => {
    fetch(`${BACKEND_URL}/api.php?module=product`)
      .then(res => res.json())
      .then(data => { if (data.success) setProducts(data.data); })
      .catch(err => console.log(err));

    fetch(`${BACKEND_URL}/api.php?module=category`)
      .then(res => res.json())
      .then(data => { if (data.success) setDbCategories(data.data); })
      .catch(err => console.log(err));
  }, []);

  useEffect(() => {
    const handleOutside = (e) => {
      if (mobilePopupRef.current && !mobilePopupRef.current.contains(e.target)) {
        setMobileSearchOpen(false);
        setShowSearch(false);
      }
      if (userRef.current && !userRef.current.contains(e.target)) setMobileUserOpen(false);
    };
    document.addEventListener("mousedown", handleOutside);
    return () => document.removeEventListener("mousedown", handleOutside);
  }, []);

  const logout = () => {

    // 1. Backend session destroy
    fetch(`${BACKEND_URL}/api.php?module=auth&action=logout`, {
      credentials: "include"
    });

    // 2. Frontend clear
    localStorage.removeItem("user");
    setUser(null);
  };

  const handleCategory = (category) => {
    navigate(`/categories/${category}`);
    setMenuOpen(false);
  };

  const filteredProducts = products
    .filter((item) =>
      item.productName?.toLowerCase().includes(search.toLowerCase()) ||
      item.slug?.toLowerCase().includes(search.toLowerCase())
    )
    .slice(0, 6);

  const activeCats = dbCategories.filter(cat => cat.status === "Active");
  const parentCategories = activeCats.filter(cat => {
    const pId = cat.parentId || cat.parent_id;
    return !pId || pId === "0" || pId === "";
  });
  const childCategories = activeCats.filter(cat => {
    const pId = cat.parentId || cat.parent_id;
    return pId && pId !== "0" && pId !== "";
  });

  const structuredCategories = parentCategories.map(parent => ({
    ...parent,
    children: childCategories.filter(child => {
      const childParentId = child.parentId || child.parent_id;
      return String(childParentId) === String(parent.id);
    })
  }));

  return (
    <nav className="navbar">

      {/* ======== ROW 1: LOGO + SEARCH + AUTH + CART ======== */}
      <div className="navbar-row1">

        {/* HAMBURGER - mobile only */}
        <div className="menu-icon" onClick={() => setMenuOpen(true)}>
          <FiMenu />
        </div>

        {/* LOGO */}
        <div className="logo" onClick={() => navigate("/")}>
          <img src={logo} alt="Medicare Logo" className="logo-img" />
        </div>

        {/* SEARCH BOX - desktop */}
        <div className="search-box" ref={searchRef}>
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search medicine, salt or condition..."
            value={search}
            onChange={(e) => { setSearch(e.target.value); setShowSearch(true); }}
            onKeyDown={(e) => {
              if (e.key === "Enter" && filteredProducts.length > 0) {
                navigate(`/product/${filteredProducts[0].slug}`);
                setSearch(""); setShowSearch(false);
              }
            }}
          />
          <button className="search-btn">Search</button>

          {showSearch && search && (
            <div className="search-dropdown">
              {filteredProducts.length > 0 ? (
                filteredProducts.map((item) => (
                  <div key={item.id} className="search-item"
                    onClick={() => { setShowSearch(false); setSearch(""); navigate(`/product/${item.slug}`); }}>
                    <img src={item.image?.startsWith("http") ? item.image : `${BACKEND_URL}/${item.image}`} alt="" />
                    <div>
                      <h4>{item.productName}</h4>
                      <p>{item.categoryName}</p>
                    </div>
                  </div>
                ))
              ) : (
                <p className="no-product">Product not found</p>
              )}
            </div>
          )}
        </div>

        

        {/* RIGHT SIDE ACTIONS */}
        <div className="nav-actions">

          {/* MOBILE SEARCH ICON */}
          <div className="mobile-search-icon"
            onClick={() => { setMobileSearchOpen(prev => !prev); setShowSearch(false); setMobileUserOpen(false); }}>
            <FiSearch />
          </div>

          {/* DESKTOP AUTH */}
          <div className="desktop-auth">
            {user ? (
              <>
                <div
                    className="user"
                    onClick={() => {
                      setAuthMode("forgot");
                      setShowAuth(true);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <FiUser />
                    <span>{user.name}</span>
                  </div>
                <button className="btn" onClick={logout}>Logout</button>
              </>
            ) : (
              <>
                <button className="btn-outline" onClick={() => { setAuthMode("signin"); setShowAuth(true); }}>Sign In</button>
                <button className="btn" onClick={() => { setAuthMode("signup"); setShowAuth(true); }}>Sign Up</button>
              </>
            )}
          </div>

          {/* CART */}
         <div
            className="cart"
            onClick={() => navigate("/cart")}
          >
            <div className="cart-icon-wrapper">

              <FiShoppingCart size={22} />

              {cartCount > 0 && (
                <span className="cart-badge">
                  {cartCount}
                </span>
              )}

            </div>
          </div>


         {/* MOBILE USER ICON */}
          <div className="mobile-user-box" ref={userRef}>
            <div className="mobile-user-icon"
              onClick={() => { setMobileUserOpen(!mobileUserOpen); setMobileSearchOpen(false); }}>
              <FiUser />
              {mobileUserOpen && (
                <div className="mobile-user-dropdown">
                  {user ? (
                    <>
                      <div className="mobile-user-name"
                        onClick={() => { setAuthMode("forgot"); setShowAuth(true); setMobileUserOpen(false); }}>
                        <FiUser size={14} />
                        <span>{user.name}</span>
                      </div>
                      <button className="mobile-logout-btn"
                        onClick={() => { logout(); setMobileUserOpen(false); }}>
                        Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <button onClick={() => { setAuthMode("signin"); setShowAuth(true); setMobileUserOpen(false); }}>Sign In</button>
                      <button onClick={() => { setAuthMode("signup"); setShowAuth(true); setMobileUserOpen(false); }}>Sign Up</button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* LANGUAGE SELECTOR */}
        <div className="language-selector">
          <button
            className="language-btn"
            onClick={() => setLangOpen(!langOpen)}
          >
           

            <img
              src={selectedFlag}
              alt="Language"
              className="selected-flag"
            />

            <FiChevronDown size={14} />
          </button>

          {langOpen && (
            <div className="language-dropdown">

              <div
                className="lang-item"
                onClick={() =>
                  changeLanguage("en","https://flagcdn.com/w20/gb.png")
                }
              >
                <img
                  src="https://flagcdn.com/w20/gb.png"
                  alt="English"
                  className="lang-flag"
                />
                <span>English</span>
              </div>

              <div
                className="lang-item"
                onClick={() =>
                  changeLanguage("es","https://flagcdn.com/w20/es.png")
                }
              >
                <img
                  src="https://flagcdn.com/w20/es.png"
                  alt="Spanish"
                  className="lang-flag"
                />
                <span>Spanish</span>
              </div>

              <div
                className="lang-item"
                onClick={() =>
                  changeLanguage("pt","https://flagcdn.com/w20/pt.png")
                }
              >
                <img
                  src="https://flagcdn.com/w20/pt.png"
                  alt="Portuguese"
                  className="lang-flag"
                />
                <span>Portuguese</span>
              </div>

              <div
                className="lang-item"
                onClick={() =>
                  changeLanguage("fr","https://flagcdn.com/w20/fr.png")
                }
              >
                <img
                  src="https://flagcdn.com/w20/fr.png"
                  alt="French"
                  className="lang-flag"
                />
                <span>French</span>
              </div>

            </div>
          )}
        </div>

        </div>
      </div>
      
      {/* MOBILE FLAGS ROW */}
    <div className="mobile-language-row">
      <span
        className="mobile-flag"
        onClick={() =>
          changeLanguage("en", "https://flagcdn.com/w20/gb.png")
        }
      >
        🇬🇧
      </span>

      <span
        className="mobile-flag"
        onClick={() =>
          changeLanguage("es", "https://flagcdn.com/w20/es.png")
        }
      >
        🇪🇸
      </span>

      <span
        className="mobile-flag"
        onClick={() =>
          changeLanguage("pt", "https://flagcdn.com/w20/pt.png")
        }
      >
        🇵🇹
      </span>

      <span
        className="mobile-flag"
        onClick={() =>
          changeLanguage("fr", "https://flagcdn.com/w20/fr.png")
        }
      >
        🇫🇷
      </span>
    </div>

      {/* ======== ROW 2: NAV LINKS - desktop only ======== */}
      <div className="navbar-row2">
        <div className="nav-links-inner">

          <Link to="/" className="nav-link">Home</Link>
          <Link to="/about" className="nav-link">About</Link>
          

          {/* DYNAMIC PARENT & CHILD CATEGORIES */}
          {structuredCategories.map((parent) => {
            const hasChildren = parent.children && parent.children.length > 0;
            return (
              <div className="nav-link nav-dropdown-wrap" key={parent.id}>
                {hasChildren ? (
                  <>
                    <span onClick={() => handleCategory(parent.slug)}>
                      {parent.categoryName} <FiChevronDown size={14} />
                    </span>
                    <div className="nav-dropdown">
                      {parent.children.map((child) => (
                        <p
                          key={child.id}
                          onClick={() => handleCategory(child.slug)}
                        >
                          {child.categoryName}
                        </p>
                      ))}
                    </div>
                  </>
                ) : (
                  <span onClick={() => handleCategory(parent.slug)}>
                    {parent.categoryName}
                  </span>
                )}
              </div>
            );
          })}

          <Link to="/blog" className="nav-link">Blogs</Link>
          <Link to="/contact" className="nav-link">Contact</Link>

        </div>
      </div>

      {/* ======== MOBILE SEARCH POPUP ======== */}
      {mobileSearchOpen && (
        <div className="mobile-search-popup" ref={mobilePopupRef}>
          <div className="mobile-search-box">
            <button className="close-search"
              onClick={() => { setMobileSearchOpen(false); setShowSearch(false); setSearch(""); }}>
              <FiX />
            </button>
            <input
              type="text"
              placeholder="Search medicine..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setShowSearch(true); }}
            />
            {showSearch && search && (
              <div className="search-dropdown" onClick={(e) => e.stopPropagation()}>
                {filteredProducts.map(item => (
                  <div key={item.id} className="search-item"
                    onClick={() => { navigate(`/product/${item.slug}`); setMobileSearchOpen(false); setShowSearch(false); setSearch(""); }}>
                    <img src={item.image?.startsWith("http") ? item.image : `${BACKEND_URL}/${item.image}`} alt="" />
                    <div><h4>{item.productName}</h4><p>{item.categoryName}</p></div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* ======== MOBILE SIDEBAR ======== */}
      {menuOpen && <div className="sidebar-overlay" onClick={() => setMenuOpen(false)} />}

      <div className={`mobile-sidebar ${menuOpen ? "active" : ""}`}>

        {/* HEADER */}
        <div className="sidebar-header">
          <div className="sidebar-logo" onClick={() => { navigate("/"); setMenuOpen(false); }}>
            <img src={logo} alt="Medicare" />
          </div>
          <button className="close-btn" onClick={() => setMenuOpen(false)}><FiX /></button>
        </div>

        {/* BODY — sirf yahi scroll hoga */}
        <div className="sidebar-body">
          <ul className="sidebar-links">
            <li><Link to="/" onClick={() => setMenuOpen(false)}>Home</Link></li>
            <li><Link to="/about" onClick={() => setMenuOpen(false)}>About</Link></li>
            {structuredCategories.map((parent) => {
              const hasChildren = parent.children && parent.children.length > 0;
              const isCatOpen = activeMobileCatId === parent.id;
              return (
                <li key={parent.id}>
                  {hasChildren ? (
                    <>
                      <div
                        className="mobile-category"
                        onClick={() => setActiveMobileCatId(isCatOpen ? null : parent.id)}
                      >
                        {parent.categoryName}{" "}
                        <FiChevronDown
                          style={{
                            transform: isCatOpen ? "rotate(180deg)" : "none",
                            transition: "transform 0.2s",
                          }}
                        />
                      </div>
                      {isCatOpen && (
                        <div className="mobile-cat-dropdown">
                          {parent.children.map((child) => (
                            <p
                              key={child.id}
                              onClick={() => handleCategory(child.slug)}
                            >
                              {child.categoryName}
                            </p>
                          ))}
                        </div>
                      )}
                    </>
                  ) : (
                    <div
                      className="mobile-category"
                      onClick={() => handleCategory(parent.slug)}
                    >
                      {parent.categoryName}
                    </div>
                  )}
                </li>
              );
            })}
            <li><Link to="/blog" onClick={() => setMenuOpen(false)}>Blogs</Link></li>
            <li><Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link></li>
          </ul>
          {/* CONTACT INFO */}
            <div className="sidebar-contact">
              <p className="sidebar-contact-label">Contact us</p>
              <a href="mailto:support@realgenericshop.com" className="sidebar-contact-item">
                <FaEnvelope className="sidebar-contact-icon email" />
                support@realgenericshop.com
              </a>
              <a href="tel:+919876543210" className="sidebar-contact-item">
                <FaPhone className="sidebar-contact-icon phone" style={{ transform: "scaleX(-1)" }} />
                +91 98765 43210
              </a>
            </div>
        </div>

        {/* AUTH — neeche fixed */}
        <div className="sidebar-auth">
          {user ? (
            <>
              <div className="sidebar-user"
                onClick={() => { setAuthMode("forgot"); setShowAuth(true); setMenuOpen(false); }}>
                <FiUser />
                <span>{user.name}</span>
              </div>
              <button className="sidebar-btn-logout" onClick={logout}>Logout</button>
            </>
          ) : (
            <>
              <button className="sidebar-btn-signup" onClick={() => { setAuthMode("signup"); setShowAuth(true); setMenuOpen(false); }}>Sign Up</button>
              <button className="sidebar-btn-signin" onClick={() => { setAuthMode("signin"); setShowAuth(true); setMenuOpen(false); }}>Sign In</button>
            </>
          )}
        </div>

      </div>
    </nav>
  );
}

export default Navbar;
